import { Col } from "react-grid-system";
import styled from "styled-components";
import theme from "themes/simple-theme";

const Block = styled(Col)`
  /* Base Styling */
  align-items: center;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  margin: 10px;
  padding: 3rem 4rem;
  background-color: ${theme.color.secondary};
  color: ${theme.color.primary};
  /* Child Styling */
  & > * {
    margin: 15px 0;
  }
  & a {
    text-decoration: none;
    font-size: 3rem;
  }
  img {
    width: 150px;
    height: 150px;
    margin-bottom: 3rem;
  }
`;

export default Block;



// WEBPACK FOOTER //
// ./src/screens/Main/Block.tsx